/**
 * Подсказка над карточкой баланса: название и процент от нормы.
 *
 * Одна подсказка на страницу, а не по штуке на карточку: карточек
 * до тридцати, и тридцать скрытых блоков в разметке — лишний вес
 * без пользы.
 *
 * Открывается наведением и нажатием: на телефоне наведения нет,
 * а цифру там посмотреть нужно.
 */
export function initBalancePopover() {
    const cards = document.querySelectorAll('.balance-card');
    if (!cards.length) return;

    const popover = document.createElement('div');
    popover.className = 'balance-popover';
    popover.innerHTML = '<span class="balance-popover__title"></span>'
        + '<span class="balance-popover__value"></span>';
    document.body.appendChild(popover);
    const title = popover.querySelector('.balance-popover__title');
    const value = popover.querySelector('.balance-popover__value');

    let current = null;

    // Профицит показываем как «>100%». Настоящие числа бывают
    // в разы больше нормы (витамин B12 — тысячи процентов), и само
    // по себе это не опасно, но объяснить это в подсказке негде.
    // Вернём точное число, когда появится разбор (решение 12.10).
    // На графиках числа остаются как есть.
    function formatPercent(raw) {
        const percent = parseFloat(raw);
        if (isNaN(percent)) return '0%';
        if (percent > 100) return '&gt;100%';
        return percent + '%';
    }

    function show(card) {
        current = card;
        title.textContent = card.getAttribute('data-title') || '';
        value.innerHTML = '<b>' + formatPercent(card.getAttribute('data-percent'))
            + '</b> от нормы';
        popover.classList.add('balance-popover--visible');

        // Позиция считается после показа: до этого ширина подсказки
        // неизвестна, и она вставала мимо центра.
        const box = card.getBoundingClientRect();
        const own = popover.getBoundingClientRect();
        let left = box.left + window.pageXOffset + box.width / 2 - own.width / 2;
        // Не выпускаем за края экрана и из-под бокового меню: у крайних
        // карточек подсказка уезжала под границу, а у первой — под меню,
        // которое перекрывает её собой (правка 10.10).
        const edge = 10;
        const sidebar = document.querySelector('.sidebar');
        const sidebarRight = sidebar && sidebar.offsetParent !== null
            ? sidebar.getBoundingClientRect().right
            : 0;
        const minLeft = Math.max(edge, sidebarRight + edge);
        left = Math.max(minLeft, Math.min(left, window.innerWidth - own.width - edge));
        popover.style.left = Math.round(left) + 'px';
        popover.style.top = Math.round(box.top + window.pageYOffset - own.height - 12) + 'px';
    }

    function hide() {
        current = null;
        popover.classList.remove('balance-popover--visible');
    }

    // Наведение — только для мыши. На телефоне браузер перед нажатием
    // подделывает наведение, и прежний код успевал открыть подсказку
    // до клика; клик видел её уже открытой и закрывал обратно. Со
    // стороны это выглядело так: первый тап по соседней карточке
    // мигает подсказкой, нужен второй (найдено владельцем 17.10).
    //
    // Указательные события отличают палец от мыши явно, поэтому
    // наведение вешается на них. Там, где их нет, остаются мышиные,
    // а касание поднимает флаг и отключает наведение до конца жизни
    // страницы: устройства с мышью и пальцем одновременно встречаются,
    // но переключаться туда-обратно им не нужно.
    const hasPointerEvents = typeof window.PointerEvent === 'function';
    let touchUsed = false;

    for (const card of cards) {
        if (hasPointerEvents) {
            card.addEventListener('pointerenter', event => {
                if (event.pointerType === 'mouse') show(card);
            });
            card.addEventListener('pointerleave', event => {
                if (event.pointerType === 'mouse') hide();
            });
        } else {
            card.addEventListener('touchstart', () => { touchUsed = true; }, { passive: true });
            card.addEventListener('mouseenter', () => { if (!touchUsed) show(card); });
            card.addEventListener('mouseleave', () => { if (!touchUsed) hide(); });
        }

        // Нажатие переключает: на своей карточке закрывает, на чужой
        // сразу открывает новую — без промежуточного тапа.
        card.addEventListener('click', event => {
            event.preventDefault();
            if (current === card) hide();
            else show(card);
        });
    }

    document.addEventListener('click', event => {
        if (current && !event.target.closest('.balance-card')) hide();
    });
    window.addEventListener('scroll', () => { if (current) hide(); }, { passive: true });
}
